export const WEEKLY_PLAN_PRODUCT_ID = "stalkie2_299_1w";
export const MONTHLY_PLAN_PRODUCT_ID = "stalkie1_999_1m";

// Legacy aliases kept for backward compatibility with old test/staging data.
export const WEEKLY_PLAN_PRODUCT_ID_LEGACY = "weekly_sub";
export const MONTHLY_PLAN_PRODUCT_ID_LEGACY = "monthly_sub";

export const PLAN_LIMITS = {
  [WEEKLY_PLAN_PRODUCT_ID]: 3,
  [MONTHLY_PLAN_PRODUCT_ID]: 3,
  [WEEKLY_PLAN_PRODUCT_ID_LEGACY]: 3,
  [MONTHLY_PLAN_PRODUCT_ID_LEGACY]: 3,
} as const;

export const DEFAULT_PAID_PLAN_LIMIT = 3;
export const FREE_PLAN_LIMIT = 0;

export function resolvePlanLimit(planKey?: string | null): number {
  if (!planKey) return FREE_PLAN_LIMIT;
  const normalizedPlanKey = planKey.toLowerCase();

  const mapped =
    PLAN_LIMITS[normalizedPlanKey as keyof typeof PLAN_LIMITS] ??
    PLAN_LIMITS[planKey as keyof typeof PLAN_LIMITS];

  if (mapped !== undefined) {
    return mapped;
  }

  // Fallback by product naming convention used in RevenueCat:
  // e.g. "stalkie2_299_1w" or "stalkie1_999_1m"
  if (normalizedPlanKey.includes("_1w")) return 3;
  if (normalizedPlanKey.includes("_1m")) return 3;

  return DEFAULT_PAID_PLAN_LIMIT;
}
